import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RadioButtonCheckedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"radio_button_checked"}/>
}
